export default function Icon(params) {
  const {
    value,
    otherFields,
    data
  } = params;
  const iconCell = document.createElement('div');
  iconCell.classList.add('w5-icon-cell');
  const buildIcon = val => {
    var _otherFields$icons;
    const iconInfo = (otherFields === null || otherFields === void 0 ? void 0 : (_otherFields$icons = otherFields.icons) === null || _otherFields$icons === void 0 ? void 0 : _otherFields$icons[val]) || (otherFields === null || otherFields === void 0 ? void 0 : otherFields.icon);
    if (!(iconInfo !== null && iconInfo !== void 0 && iconInfo.svg) && !(iconInfo !== null && iconInfo !== void 0 && iconInfo.getSvg)) return;
    const iconWrapper = document.createElement('div');
    iconWrapper.classList.add(`w5-icon-cell-wrapper`);
    iconWrapper.classList.add(`w5-icon-cell-${val}`);
    let svg;
    if (iconInfo.svg) svg = iconInfo.svg;else if (iconInfo.getSvg) svg = iconInfo.getSvg(params.data);
    if (!svg) return;
    iconWrapper.innerHTML = svg;
    if (iconInfo !== null && iconInfo !== void 0 && iconInfo.onClick) {
      iconWrapper.addEventListener('click', event => {
        iconInfo.onClick(event, data);
      });
      iconWrapper.classList.add(`w5-icon-cell-pointer`);
    }
    iconCell.appendChild(iconWrapper);
    if (iconInfo !== null && iconInfo !== void 0 && iconInfo.className) {
      iconCell.classList.add(iconInfo.className);
    }
  };
  if (!Array.isArray(value)) {
    buildIcon(value);
  } else {
    value.forEach(current => buildIcon(current));
  }
  return iconCell;
}